import type { SVGComponentProps } from 'BreetHelpers';

export const BvnValidationIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='80'
		height='80'
		viewBox='0 0 80 80'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M65 7.5H20C17.9289 7.5 16.25 9.17893 16.25 11.25V73.75C16.25 75.8211 17.9289 77.5 20 77.5H65C67.0711 77.5 68.75 75.8211 68.75 73.75V11.25C68.75 9.17893 67.0711 7.5 65 7.5Z'
			fill='#C0DAFB'
		/>
		<path
			d='M60 2.5H15C12.9289 2.5 11.25 4.17893 11.25 6.25V68.75C11.25 70.8211 12.9289 72.5 15 72.5H60C62.0711 72.5 63.75 70.8211 63.75 68.75V6.25C63.75 4.17893 62.0711 2.5 60 2.5Z'
			fill='#E3E8F6'
		/>
		<path
			d='M60 2.5H15V63.75C15 64.7446 15.3951 65.6984 16.0983 66.4016C16.8016 67.1049 17.7554 67.5 18.75 67.5H63.75V6.25C63.75 5.25544 63.3549 4.30161 62.6516 3.59835C61.9484 2.89509 60.9946 2.5 60 2.5Z'
			fill='#F8F7FE'
		/>
		<path
			d='M37.5 65C46.4746 65 53.75 57.7246 53.75 48.75C53.75 39.7754 46.4746 32.5 37.5 32.5C28.5254 32.5 21.25 39.7754 21.25 48.75C21.25 57.7246 28.5254 65 37.5 65Z'
			fill='#559B38'
		/>
		<path
			d='M39.375 64.8847C47.3141 64.8847 53.75 57.6614 53.75 48.7509C53.75 39.8405 47.3141 32.6172 39.375 32.6172C31.4359 32.6172 25 39.8405 25 48.7509C25 57.6614 31.4359 64.8847 39.375 64.8847Z'
			fill='#6BC148'
		/>
		<path
			d='M33.2763 48.2762L35 50L41.7238 43.2762C41.97 43.03 42.2623 42.8347 42.584 42.7015C42.9057 42.5683 43.2505 42.4999 43.5988 42.5C44.3018 42.5003 44.976 42.7798 45.4731 43.2769C45.9702 43.774 46.2497 44.4482 46.25 45.1512C46.2501 45.4995 46.1817 45.8443 46.0485 46.166C45.9153 46.4877 45.72 46.78 45.4738 47.0262L37.1338 55.3662C36.8535 55.6464 36.5209 55.8687 36.1548 56.0203C35.7887 56.172 35.3963 56.25 35 56.25C34.6037 56.25 34.2113 56.172 33.8452 56.0203C33.4791 55.8687 33.1465 55.6464 32.8662 55.3662L29.5263 52.0262C29.28 51.78 29.0847 51.4877 28.9515 51.166C28.8183 50.8443 28.7499 50.4995 28.75 50.1512C28.7503 49.4482 29.0298 48.774 29.5269 48.2769C30.024 47.7798 30.6982 47.5003 31.4013 47.5C31.7495 47.4999 32.0943 47.5683 32.416 47.7015C32.7377 47.8347 33.03 48.03 33.2763 48.2762Z'
			fill='#F8F7FE'
		/>
		<path
			d='M16.25 7.5H23.75V12.5H16.25V7.5Z'
			fill='#559B38'
		/>
		<path
			d='M21.25 10H23.75V7.5H18.75C18.75 8.16304 19.0134 8.79893 19.4822 9.26777C19.9511 9.73661 20.587 10 21.25 10Z'
			fill='#6BC148'
		/>
		<path
			d='M27.5 6.25H48.75V8.75H27.5V6.25Z'
			fill='#6BC148'
		/>
		<path
			d='M27.5 11.25H55V13.75H27.5V11.25Z'
			fill='#6BC148'
		/>
		<path
			d='M57.5 11.25H60V13.75H57.5V11.25Z'
			fill='#6BC148'
		/>
		<path
			d='M27.5 18.75H48.75V21.25H27.5V18.75Z'
			fill='#6BC148'
		/>
		<path
			d='M27.5 23.75H55V26.25H27.5V23.75Z'
			fill='#6BC148'
		/>
		<path
			d='M57.5 23.75H60V26.25H57.5V23.75Z'
			fill='#6BC148'
		/>
		<path
			d='M16.25 20H23.75V25H16.25V20Z'
			fill='#559B38'
		/>
		<path
			d='M21.25 22.5H23.75V20H18.75C18.75 20.663 19.0134 21.2989 19.4822 21.7678C19.9511 22.2366 20.587 22.5 21.25 22.5Z'
			fill='#6BC148'
		/>
	</svg>
);
